import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

const ProductCard = ({ product, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (index % 3) * 0.1 }}
  >
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block border border-white/10 bg-forest-900 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-400/50 hover:shadow-[0_20px_60px_rgba(0,0,0,0.45)]"
    >
      <div className={`relative aspect-[4/3] overflow-hidden ${product.packshot ? "bg-white" : ""}`}>
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className={product.packshot
            ? "h-full w-full object-contain p-8 transition-transform duration-700 group-hover:scale-105"
            : "h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"}
        />
        <div className={`absolute inset-0 ${product.packshot ? "" : "bg-gradient-to-t from-white/90 via-white/10 to-transparent"}`} />
        {product.is_new && (
          <span className="absolute right-4 top-4 bg-gold-300 px-3 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.25em] text-forest-950" data-testid={`new-badge-${product.slug}`}>
            New Launch
          </span>
        )}
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-display text-2xl font-bold tracking-tight text-foreground group-hover:text-brand-400">
            {product.name}
          </h3>
          <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-sage transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-brand-400" />
        </div>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-mist">{product.tagline}</p>
      </div>
    </Link>
  </motion.div>
);

export default ProductCard;
